<template>
<div>
  <section class="hero is-primary" id="head-section">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h2 class="title">输出手簿</h2>
      </div>
    </div>
  </section>

  <!-- <section class="section">
    <div class="container"> -->

<div class="card">
  <header class="card-header">
    <p class="card-header-title">
      原始观测数据
    </p>
  </header>
  <div class="card-content">
    <div class="file has-name">
      <label class="file-label">
        <input class="file-input" type="file" @change="previewFile">
        <span class="file-cta">
          <span class="file-icon">
            <i class="fas fa-upload"></i>
          </span>
          <span class="file-label">
            选择 .dat 文件…
          </span>
        </span>
        <span class="file-name">
          <!-- {{ file.name }} -->
          <i v-if="file === ''" style="color:gray">&lt;未选择文件&gt;</i>
          <p v-else>{{ file.name }}</p>
        </span>
      </label>
    </div>
    <span v-if="file != ''">
      <p class="addition-text">文件最后修改日期：{{ dataFileTime }}</p>
    </span>
  </div>
</div>

<div class="columns is-multiline is-mobile is-gapless">
  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          太阳方向
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.sun">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsSun" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          风向风速
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.wind">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsWind" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          天气
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.weather">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsWeather" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          成像
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.image">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsImage" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          土质（地面）
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.ground">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsGround" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column is-half">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          精度等级
        </p>
      </header>
      <div class="card-content">
        <div class="control">
          <label class="select">
            <select v-model="selectedItem.preciseGrade">
              <option style="display:none" value=""> -- 请选择 -- </option>
              <option v-for="item in itemsPreciseGrade" :key="item.value">
                {{ item.value }}
              </option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="column">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          温度
        </p>
      </header>
      <div class="card-content">
        <input class="input" type="number" placeholder="摄氏度" v-model="temperature">
      </div>
    </div>

    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          操作人员
        </p>
      </header>
      <div class="card-content">
        <!-- <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">观测者</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <input class="input" type="text" v-model="name.observer">
              </p>
            </div>
          </div>
        </div> -->
        <input class="input" type="text" placeholder="观测者" v-model="name.observer">
        <br/><br/>

        <input class="input" type="text" placeholder="记录者" v-model="name.recorder">
        <br/><br/>

        <input class="input" type="text" placeholder="检核者" v-model="name.checker">
      </div>

      <div class="card-footer">
        <button
          class="card-footer-item is-primary"
          :disabled="!isFillComplete"
          @click="submit"
        >
          提交
        </button>
      </div>
    </div>
  </div>

</div>

<!-- <div class="card">
  <header class="card-header">
    <p class="card-header-title">
      仪器型号
    </p>
  </header>
  <div class="card-content">
    <input class="input" type="text" v-model="deviceModel">
  </div>
</div> -->

    <!-- </div>
  </section> -->

<div class="modal" v-bind:class="{ 'is-active': isShowModalWaiting }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <section class="modal-card-body">
      <div style="text-align: center;">
        <button class="button is-white is-large is-loading">Loading</button>
      </div>
    </section>
  </div>
</div>
<div class="modal" v-bind:class="{ 'is-active': isShowModalMessage}">
  <div class="modal-background" v-on:click="isShowModalMessage = false"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">注意</p>
      <button class="delete" aria-label="close" v-on:click="isShowModalMessage = false"></button>
    </header>
    <section class="modal-card-body">
      {{ showMessage }}
    </section>
    <footer class="modal-card-foot">
      <button class="button" v-on:click="isShowModalMessage = false">返回</button>
    </footer>
  </div>
</div>

</div>
</template>

<script>
import { SubmitInfoOptions, base64e4url } from '@/utils'
// import the vuex helper function called mapState
// import { mapState } from 'vuex'
export default {
  data () {
    return {
      file: '',
      dataFileTime: '',
      itemsSun: SubmitInfoOptions.sun,
      itemsWind: SubmitInfoOptions.wind,
      itemsWeather: SubmitInfoOptions.weather,
      itemsImage: SubmitInfoOptions.image,
      itemsGround: SubmitInfoOptions.ground,
      itemsPreciseGrade: SubmitInfoOptions.preciseGrade,
      selectedItem: {
        sun: '', wind: '', weather: '', image: '', ground: '', preciseGrade: ''
      },
      deviceModel: '',
      temperature: '',
      name: {
        observer: '', recorder: '', checker: ''
      },
      isShowModalWaiting: false,
      isShowModalMessage: false,
      showMessage: ''
    }
  },
  methods: {
    previewFile (evt) {
      var allowedExtensions = /(\.dat)$/i
      if (!allowedExtensions.exec(evt.target.files[0].name)) {
        this.file = ''
        this.dataFileTime = ''
        this.isShowModalMessage = true
        this.showMessage = '无效的数据格式！请重新选择。'
        return
      }
      this.file = evt.target.files[0]
      // console.log(this.file)
      var date = new Date(this.file.lastModified)
      this.dataFileTime = date.toLocaleDateString()
    },
    submit (evt) {
      this.isShowModalWaiting = true
      var formData = new FormData()
      formData.append('file', this.file, this.file.name)
      const jsonBody = JSON.stringify({
        'Date': this.dataFileTime,
        'Sun': this.selectedItem.sun,
        'Wind': this.selectedItem.wind,
        'Weather': this.selectedItem.weather,
        'Image': this.selectedItem.image,
        'Ground': this.selectedItem.ground,
        // 'PreciseGrade': this.selectedItem.preciseGrade, // 实际没有用到这个参数
        'Temperature': this.temperature,
        'Observer': this.name.observer,
        'Recorder': this.name.recorder,
        'Checker': this.name.checker
      })
      formData.append('params', jsonBody)

      this.$store.dispatch('submitLevelData', formData, {})
        .then(res => {
          this.isShowModalWaiting = false
          console.log({res})
          var nameTrim = this.file.name.split('.').slice(0, -1).join('.')
          // var id = res.data['result'].split('/' + nameTrim)[1]
          this.$router.push('/download/' + base64e4url(nameTrim) + '/' + base64e4url(res.data['result']))
        }).catch(error => {
          console.log({'Error Posting': error})
          this.isShowModalWaiting = false
          this.showMessage = '出现了一个错误'
          // TODO: if
          if (error.response.status === 403) {
            this.showMessage += ': missing openid'
          } else if (error.response.status === 502) {
            this.showMessage += ': 算法后端程序发生内部错误'
          }
          this.isShowModalMessage = true
        })
    }
  },
  computed: {
    isFillComplete () {
      if (this.file === '' ||
        this.dataFileTime === '' ||
        this.selectedItem.sun === '' ||
        this.selectedItem.wind === '' ||
        this.selectedItem.weather === '' ||
        this.selectedItem.image === '' ||
        this.selectedItem.ground === '' ||
        this.selectedItem.preciseGrade === '' ||
        this.temperature === '' ||
        this.name.observer === '' ||
        this.name.recorder === '' ||
        this.name.checker === ''
      ) {
        return false
      }
      return true
    }
  }
}
</script>

<style>
button.card-footer-item {
  background-color: transparent;
  cursor: pointer;
  color: link;
  border: 0;
  font-size: 1rem;
  line-height: 1.5;
}
p.addition-text {
  margin-top: 10px;
}
.overflow-hidden {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/FeatureOne.vue